interface StatusBarProps {
  mode: 'sale' | 'tender' | 'return';
}

export default function StatusBar({ mode }: StatusBarProps) {
  return (
    <div className="bg-gray-800 text-white px-6 py-2.5 flex items-center justify-between border-t border-gray-700">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 whitespace-nowrap">Current Mode:</span>
          <span className={`px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap ${
            mode === 'sale' 
              ? 'bg-teal-500 text-white' 
              : mode === 'tender'
              ? 'bg-green-500 text-white'
              : 'bg-cyan-500 text-white'
          }`}>
            {mode === 'sale' ? 'SALE' : mode === 'tender' ? 'TENDER' : 'RETURN'}
          </span>
        </div>

        <div className="h-5 w-px bg-gray-600"></div>

        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-green-500"></div>
          <span className="text-xs text-gray-300 whitespace-nowrap">Scanner Connected</span>
        </div>

        <div className="h-5 w-px bg-gray-600"></div>

        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 whitespace-nowrap">User Role:</span>
          <span className="text-xs font-semibold text-white whitespace-nowrap">Cashier</span>
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <i className="ri-alert-line text-amber-400"></i>
          <span className="text-xs text-gray-300 whitespace-nowrap">Alerts:</span>
          <span className="px-2 py-0.5 bg-amber-500 text-white rounded-full text-xs font-bold whitespace-nowrap">0</span>
        </div>

        <div className="h-5 w-px bg-gray-600"></div>

        <div className="flex items-center gap-2">
          <i className="ri-wifi-off-line text-gray-400"></i>
          <span className="text-xs text-gray-300 whitespace-nowrap">Offline Queue:</span>
          <span className="px-2 py-0.5 bg-gray-600 text-white rounded-full text-xs font-bold whitespace-nowrap">0</span>
        </div>

        <div className="h-5 w-px bg-gray-600"></div>

        <div className="flex items-center gap-2">
          <i className="ri-keyboard-line text-gray-400"></i>
          <span className="text-xs text-gray-400 whitespace-nowrap">Powered by Biznify</span>
        </div>
      </div>
    </div>
  );
}
